import { parseDate, compare } from './helpers';

export function mapMediaData(mediaData, excludeFilters = [], mediaType = '') {
  return dataMapper(mediaData, excludeFilters, mediaType);
}

export function filterMedia(mediaData, filters = [], type="include") {
  if (!filters.length) {
    return mediaData;
  }

  const includesOrEquasl = (itemVal, fieldVal) => {
    if (Array.isArray(fieldVal) && !Array.isArray(itemVal)) {
      return fieldVal.includes(itemVal);
    }

    return itemVal === fieldVal;
  };

  const condition = (boolVal) => type === "include" ? boolVal : !boolVal;
  const filterCheck = (item) => {
    return condition(filters.some((fields) => 
      Object.keys(fields).every((key) => (item[key] && includesOrEquasl(item[key], fields[key])) === true)
    ));
  };

  return mediaData.filter((item) => filterCheck(item));
}

export function mergeMediaData(mediaData1, mediaData2) {
  let mediaData3 = Object.assign({}, mediaData2);

  for(let item in mediaData1) {
    if (item in mediaData3) {
      mediaData3[item] = Object.assign({}, mediaData3[item], mediaData1[item]);
    } else {
      mediaData3[item] = mediaData1[item];
    }
    
  }

  return mediaData3;
} 

export function getMediaRelatedContentTypeByUrl(mediaData, url) {

}

export function getMediaContentType(mediaData, type, format="web", sortBy="mediaDate", sortDirection="ASC") {
  /*eslint no-dupe-else-if: 0*/
  // TODO: Include Sort Direction
  const itemVal = item => item[sortBy];
  const sortFunc = (a, b) => {
    const val1 = itemVal(a);
    const val2 = itemVal(b);

    if ((!val1 && !val2) || compare(val1, val2)) {
      return 0;
    } else if (!val1) {
      return sortDirection === "ASC" ? 1 : -1;
      // TODO: Is Something Wrong with this logic. Please Investigate. Should it be checking !val2?
    } else if (!val1) {
       return sortDirection === "ASC" ? -1 : 1;
    }

    return compare(val1, val2, ">") && sortDirection === "ASC" ? 1 : -1;
  };

  const data = filterMedia(mediaData, [{contentTypeCode: type, format: format}], "include");

  if (sortBy) {
    // return data.concat().sort(sortFunc);
  }

  return data;
}

export function dataMapper(mediaData, excludeFilters=[], mediaType = '') {
  if (!mediaData || !Array.isArray(mediaData) || !mediaData.length) {
    return {};
  }

  const verify = (item) => {
    return !!(item && 
      item.url && 
      item.contentTypeCode && 
      item.format && 
      item.mediaDate) === true;
  };

  // Create a unique key for the media based on the file name
  const getKey = (url) => {
    var filename = url.substring(url.lastIndexOf('/')+1); 
    filename = filename.substring(0, filename.indexOf("."));
    var array = filename.split("_");
    return array[0] + "_" + array[1] + "_" + array[2] + "_" + array[3];
  };

  const addToColl = (coll, {year, type, format, url, data, mediaType = ''}) => {
    data.mediaType = mediaType;

    let key = getKey(url);

    if (!coll[year]) {
      coll[year] = {};
    }

    if (!coll[year][key]) {
      coll[year][key] = {};
    }

    if (!coll[year][key][format]) {
      coll[year][key][format] = {};
    }

    if (!coll[year][key][format][url]) {
      coll[year][key][format][url] = data;
    }

    return coll;
  };

  const filteredMedia = filterMedia(mediaData, excludeFilters, "exclude");


  const mappedData = filteredMedia.reduce((coll, item) => {
    try {
      if (!verify(item)) {
        return coll;
      }

      const { url, contentTypeCode, format, mediaDate } = item;
      const { year } = parseDate(mediaDate);

      return addToColl(coll, {
        year, 
        type: contentTypeCode, 
        format, 
        url,
        data: item,
        mediaType: mediaType  
      });
    } catch (err) {
      // TODO Log Error
      console.log(err);
      return coll;
    }
  }, {});

  return mappedData;
}

export const CHILD_LETTER_CODE = "CCS";